import { Head } from '@inertiajs/react';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import type { AdminTeamsIndex } from '@/types';
import { CreateTeamDialog } from './components/CreateTeamDialog';
import { TeamsTable } from './components/TeamsTable';

export default function Index({
  teams,
  eventSlug,
  eventName,
  title,
}: AdminTeamsIndex) {
  return (
    <>
      <Head title={title} />
      <div className="container mx-auto space-y-6 py-8">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="font-bold text-3xl tracking-tight">Teams</h1>
            <p className="text-muted-foreground">
              Manage hackathon teams and their members for {eventName}
            </p>
          </div>
          <CreateTeamDialog eventSlug={eventSlug} />
        </div>

        <Card>
          <CardHeader>
            <CardTitle>All Teams ({teams.length})</CardTitle>
          </CardHeader>
          <CardContent className="p-0">
            <TeamsTable eventSlug={eventSlug} teams={teams} />
          </CardContent>
        </Card>
      </div>
    </>
  );
}
